module.exports = __webpack_public_path__ + "assets/img/star-news-active.0b3a938f.svg";